import store from '../store';

export const convertUTCToLocal = (dateTime, timezoneOffset = 0) => {
    let original = new Date(dateTime);
    let offset = 0;
    offset = store.getters.loggedInUser.mytimezone;

    if (!offset)
        offset = parseInt(localStorage.getItem('mytimezone'))

    console.log('offset', offset)
    
    original.setTime(original.getTime() + (timezoneOffset + offset) * 60 * 60 * 1000);
    return original;
}

export const defaultFormat = (dateTime) => {
    // let original = new Date(dateTime);
    // const year = original.getFullYear();
    // const month = original.getMonth() + 1;
    // const day = original.getDate();
    // const hour = original.getHours();
    // const minute = original.getMinutes();
    // const second = original.getSeconds();
    // const mon = `${Math.floor(month / 10)}${month % 10}`;
    // const d = `${Math.floor(day / 10)}${day % 10}`;
    // const h = `${Math.floor(hour / 10)}${hour % 10}`;
    // const min = `${Math.floor(minute / 10)}${minute % 10}`;
    // const s = `${Math.floor(second / 10)}${second % 10}`;
    // return `${month}/${day}/${year} ${hour}:${minute}:${second}`;
    let original = new Date(dateTime);
    let  year = original.getFullYear();
    let month = original.getMonth() + 1;
    if ( month < 10 )
        month = "0" + month;
    let day = original.getDate();
    if ( day < 10 )
        day = "0" + day;
    let hour = original.getHours();
    if ( hour < 10 )
        hour = "0" + hour;
    let minute = original.getMinutes();
    if ( minute < 10 )
        minute = "0" + minute;
    let second = original.getSeconds();
    if ( second < 10 )
        second = "0" + second;
    const mon = `${Math.floor(month / 10)}${month % 10}`;
    const d = `${Math.floor(day / 10)}${day % 10}`;
    const h = `${Math.floor(hour / 10)}${hour % 10}`;
    const min = `${Math.floor(minute / 10)}${minute % 10}`;
    const s = `${Math.floor(second / 10)}${second % 10}`;
    //return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    return `${day}/${month}/${year} ${hour}:${minute}:${second}`;
}

export const defaultFormat2 = (dateTime) => {
    let original = new Date(dateTime);
    let  year = original.getFullYear();
    let month = original.getMonth() + 1;
    if ( month < 10 )
        month = "0" + month;
    let day = original.getDate();
    if ( day < 10 )
        day = "0" + day;
    let hour = original.getHours();
    if ( hour < 10 )
        hour = "0" + hour;
    let minute = original.getMinutes();
    if ( minute < 10 )
        minute = "0" + minute;
    let second = original.getSeconds();
    if ( second < 10 )
        second = "0" + second;
    const mon = `${Math.floor(month / 10)}${month % 10}`;
    const d = `${Math.floor(day / 10)}${day % 10}`;
    const h = `${Math.floor(hour / 10)}${hour % 10}`;
    const min = `${Math.floor(minute / 10)}${minute % 10}`;
    const s = `${Math.floor(second / 10)}${second % 10}`;
    //return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    return `${day}/${month}/${year} ${hour}:${minute}:${second}`;
}

export const valueDate = (dateTime) => {
    let original = new Date(dateTime);
    let  year = original.getFullYear();
    let month = original.getMonth() + 1;
    if ( month < 10 )
        month = "0" + month;
    let day = original.getDate();
    if ( day < 10 )
        day = "0" + day;
    let hour = original.getHours();
    if ( hour < 10 )
        hour = "0" + hour;
    let minute = original.getMinutes();
    if ( minute < 10 )
        minute = "0" + minute;
    let second = original.getSeconds();
    if ( second < 10 )
        second = "0" + second;
    const mon = `${Math.floor(month / 10)}${month % 10}`;
    const d = `${Math.floor(day / 10)}${day % 10}`;
    const h = `${Math.floor(hour / 10)}${hour % 10}`;
    const min = `${Math.floor(minute / 10)}${minute % 10}`;
    const s = `${Math.floor(second / 10)}${second % 10}`;
    //return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    return `${year}-${month}-${day}`;
}

export const labelDate = (dateTime) => {
    let original = new Date(dateTime);
    let  year = original.getFullYear();
    let month = original.getMonth() + 1;
    if ( month < 10 )
        month = "0" + month;
    let day = original.getDate();
    if ( day < 10 )
        day = "0" + day;
    let hour = original.getHours();
    if ( hour < 10 )
        hour = "0" + hour;
    let minute = original.getMinutes();
    if ( minute < 10 )
        minute = "0" + minute;
    let second = original.getSeconds();
    if ( second < 10 )
        second = "0" + second;
    const mon = `${Math.floor(month / 10)}${month % 10}`;
    const d = `${Math.floor(day / 10)}${day % 10}`;
    const h = `${Math.floor(hour / 10)}${hour % 10}`;
    const min = `${Math.floor(minute / 10)}${minute % 10}`;
    const s = `${Math.floor(second / 10)}${second % 10}`;
    //return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    return `${day}/${month}/${year}`;
}

export const defaultHM = (dateTime) => {
    let original = new Date(dateTime);
    
    var hour = original.getHours();
    var minute = original.getMinutes();
    if (hour < 10)
        hour = '0' + hour;
    if (minute < 10)
        minute = '0' + minute;
    
    return `${hour}:${minute}`;
}

export const getYear = (dateTime) => {
    let original = new Date(dateTime);
    const year = original.getFullYear();
    const month = original.getMonth() + 1;
    const day = original.getDate();
   
    return year;
}

export const getMonth = (dateTime) => {
    let original = new Date(dateTime);
    const year = original.getFullYear();
    const month = original.getMonth() + 1;
    const day = original.getDate();
   
    return month;
}

export const getDay = (dateTime) => {
    let original = new Date(dateTime);
    const year = original.getFullYear();
    const month = original.getMonth() + 1;
    const day = original.getDate();
   
    return day;
}

